<script setup>
import SiteLayout from '@/Layouts/Layout.vue';
import DomainAnalysisForm from '@/Pages/DomainAnalysis/Partials/DomainAnalysisForm.vue';
</script>

<template>
  <SiteLayout
    :title="$t('domain_analysis.index.domain_analysis_dmarc_spf')"
    :description="
      $t('domain_analysis.index.domain_analysis_dmarc_spf_description')
    "
  >
    <DomainAnalysisForm />
  </SiteLayout>
</template>
